var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDouble1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.223,2.058a1.5,1.5,0,0,0-2.037.591L12.693,18.08,6.462,11.286a1.5,1.5,0,1,0-2.211,2.027l7.643,8.335a1.518,1.518,0,0,0,2.42-.291L23.814,4.1A1.5,1.5,0,0,0,23.223,2.058Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.605,14.625A1.5,1.5,0,0,0,.394,16.653l4.581,5a1.517,1.517,0,0,0,2.119.091,1.5,1.5,0,0,0,.092-2.119Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3,12.973a1.407,1.407,0,0,0,2.01-.54L16.894,4.1a1.5,1.5,0,1,0-2.627-1.446L9.678,10.986A1.425,1.425,0,0,0,10.3,12.973Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDouble1);
export default __webpack_public_path__ + "static/media/check-double-1.7c60a7947e9520a543b920e2626012e2.svg";
export { ForwardRef as ReactComponent };